import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import setProjectState from 'store/setProjectState';

import store, { IProjectState } from 'store';
import { components } from 'api/types';

type WorkflowSummary = components['schemas']['WorkflowSummary'];

function applyRename(projectId: string, runId: string, name: string, updatedUtc?: string) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      const run = state.runsAsync.data?.items.find((r) => r.id === runId);
      if (!run) return;
      run.name = name;
      if (updatedUtc) run.updated_utc = updatedUtc;
    }),
  );
}

export default async function renameRun(runId: string, newName: string) {
  const projectId = getProjectId();
  if (!projectId) throw new Error('No project ID');

  const previousName = store.getState().projectStateMap[projectId]?.runsAsync.data?.items.find(
    (r) => r.id === runId,
  )?.name;
  if (previousName === undefined) throw new Error('Run not in store');

  applyRename(projectId, runId, newName);

  try {
    const summary = await api
      .post(`projects/${projectId}/workflows/${runId}/operations`, {
        json: { type: 'RENAME', name: newName },
      })
      .json<WorkflowSummary>();
    applyRename(projectId, runId, summary.name, summary.updated_utc);
  } catch (error) {
    applyRename(projectId, runId, previousName);
    Sentry.captureException(error);
    throw error;
  }
}
